import z from 'zod';

export const ISODate = z.string().refine((s) => !!s.match(/^\d{4}-\d{2}-\d{2}$/), 'Should be a valid ISO date');

export const ISOTime = z.string().refine((s) => !!s.match(/^\d{2}:\d{2}:\d{2}(\.\d+)?$/), 'Should be a valid ISO time');

export const ISODatetime = z
  .string()
  .refine((s) => !!s.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/), 'Should be a valid ISO datetime');

export const ISODuration = z
  .string()
  .refine((s) => !!s.match(/^(\d+\.)?\d{2}:\d{2}:\d{2}(\.\d+)?$/), 'Should be a valid ISO time');
